import OliverText from "@builder/components/general/OliverText";
import SimpleCheckbox from "@builder/components/general/SimpleCheckbox";
import SkeletonText from "@builder/components/general/SkeletonText";
import { ActionEditorItem, updateStepperActions } from "@builder/store/slices/actionBuilderSlice";
import { useGetRolesQuery } from "@builder/store/slices/dataApiSlices/rolesApiSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { ActionType } from "@common/build/types";
import { skipToken } from "@reduxjs/toolkit/query";
import { useEffect, useState } from "react";

const getSelectedRoles = (ids: string[]) => {
    if (!ids) return {};

    const selectedRoles: Record<string, boolean> = {};
    ids.map(item => (selectedRoles[item] = true));
    return selectedRoles;
};

const AuthenticateUser = () => {
    const { id } = useAppSelector(state => state.actionBuilder.current);
    const actionStep = useAppSelector(state => state.actionBuilder.actionsEditor.find(item => item.id === id));
    const { isOrg, company, data } = useAppSelector(state => state.storeData);
    const selectedCompany = data?.company;
    const [selectedRoles, setSelectedRoles] = useState<Record<string, boolean>>(getSelectedRoles(actionStep?.action?.data?.ids) || {});
    const dispatch = useAppDispatch();

    const { data: roles, isLoading: isLoadingRoles } = useGetRolesQuery(
        company?._id && selectedCompany?._id ? { companyId: selectedCompany._id, ...(isOrg && { organizationId: company._id }) } : skipToken
    );

    useEffect(() => {
        const selectedIds = Object.keys(selectedRoles).filter(key => selectedRoles[key]);

        const action = {
            type: ActionType.AUTHENTICATE,
            data: { ids: selectedIds }
        };
        const updatedStep = { ...actionStep };
        updatedStep.action = { ...action };

        if (JSON.stringify(updatedStep) !== JSON.stringify(actionStep)) {
            dispatch(updateStepperActions({ id: id, item: updatedStep as ActionEditorItem }));
        }
    }, [actionStep, dispatch, id, selectedRoles]);

    const toggleSelection = (roleId: string) => {
        setSelectedRoles(prevSelectedRoles => ({
            ...prevSelectedRoles,
            [roleId]: !prevSelectedRoles[roleId]
        }));
    };

    // const tPrefix = "popup.actionBuilder.";

    return (
        <div className="function-add-cart-note-wrapper">
            <div className="function-add-cart-note">
                {isLoadingRoles ? (
                    <SkeletonText />
                ) : (
                    <>
                        {roles && roles.length > 0
                            ? roles.map(item => (
                                  <div key={item._id} className="function-checkbox-wrapper" onClick={() => toggleSelection(item._id)}>
                                      <div className="function-checkbox-label-wrapper">
                                          <OliverText text={item.name} size="xs" weight="medium-heavy" />
                                      </div>
                                      <SimpleCheckbox
                                          callback={toggleSelection}
                                          checked={selectedRoles?.[item._id] || false}
                                          label=""
                                          value={item._id}
                                          custom={false}
                                      />
                                  </div>
                              ))
                            : null}
                    </>
                )}
            </div>
        </div>
    );
};

export default AuthenticateUser;
